import { useEffect, useRef, useState } from 'react'

import { EMPTY_STRING } from '../../../../../../constants/common'
import { useCopyToClipboard, useNotification } from '../../../../../../hooks'
import { EPOST_TIMELINE_TRACKING_ID_COPY_BUTTON_DISABLED_TIMEOUT } from '../../EpostStatusTimelineTrackingId.constants'

export function useEpostStatusTimelineTrackingIdCopy({ trackingId }) {
  const [, copy] = useCopyToClipboard()

  const [copied, setCopied] = useState(false)

  const timerRef = useRef(null)

  const { handleAddSuccessNotification } = useNotification()

  function handleCopyId() {
    copy(trackingId).then(() => {
      setCopied(true)
      handleAddSuccessNotification(
        'Notification.EpostStatusTimelineCopiedTitleKey'
      )
    })
  }

  useEffect(() => {
    // to disable copy button for 5 sec
    if (copied) {
      timerRef.current = setTimeout(() => {
        copy(EMPTY_STRING)
        setCopied(false)
      }, EPOST_TIMELINE_TRACKING_ID_COPY_BUTTON_DISABLED_TIMEOUT)
    }

    return () => {
      copy(EMPTY_STRING)
      clearTimeout(timerRef.current)
    }
  }, [copied])

  return {
    copied,
    handleCopyId,
  }
}
